// TODO: move into i18n/types
import { AxiosResponse } from "axios";
import { ApiV4ResponseWrapper } from "../../../../../modules/Designer/types";
import { isResponseTypeIdMatching } from "../../utils";
import { TypeIds } from "../../../../model/schemas";
import { StreamCalculation } from "../../../../model/schemas/StreamCalculation";
import { translateApiName } from "../../../../../config/i18n/utils";
import { i18nDataTypeKey, i18nFormatTypeKey } from "../../constants";
import { TYPE_PROPERTY_PROPERTY_INTERACTION_TYPE_ID_MAP } from "../../../../constants";

export const isStreamCalculationsResponse = (
  response: AxiosResponse<ApiV4ResponseWrapper<unknown>>
): response is AxiosResponse<ApiV4ResponseWrapper<StreamCalculation[]>> =>
  isResponseTypeIdMatching(response, TypeIds.StreamCalculation);

export const mutablyParseStreamCalculations = (response: AxiosResponse<ApiV4ResponseWrapper<StreamCalculation[]>>) => {
  response.data.data = response.data.data.map(calculation => {
    return {
      ...calculation,
      [i18nDataTypeKey]: translateApiName(calculation.$typeId, calculation.dataType),
      [i18nFormatTypeKey]: translateApiName(
        TYPE_PROPERTY_PROPERTY_INTERACTION_TYPE_ID_MAP[calculation.dataType] ?? calculation.$typeId,
        String(calculation.formatType),
      ),
    };
  });

  return response;
}
